// extracted by mini-css-extract-plugin
export default {"blockageClosedIcon":"styles_blockageClosedIcon__uKkDq","blockageClosedContainer":"styles_blockageClosedContainer__86FLK"};